export class LoginModel {
  public userIdentifier: string = '';
  public password: string = '';
}
